import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { NotificationData, NotificationRoutes } from 'lib/notifications';
import { NotificationData as Notification } from 'services/notifications/type';
import { Button } from 'components/ui/button';

export default function NotificationDetail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const notificationData = location.state as Notification;

  const notificationItem =
    NotificationData?.[
      notificationData?.category as keyof typeof NotificationData
    ];
  const onNavigate = () => {
    const route =
      NotificationRoutes[
        notificationData?.category as keyof typeof NotificationRoutes
      ];
    navigate(route);
  };

  return (
    <div className=''>
      <div className='pt-4 pl-4 md:absolute -top-4 left-20'>
        <Button
          variant='outline'
          onClick={() => navigate(-1)}
          className='py-2 text-sm border-gray-400 h-9 hover:bg-transparent lg:h-10'
        >
          <ChevronLeft className='size-4' /> {t('back')}
        </Button>
      </div>

      <div className='relative flex flex-col items-center justify-center max-w-lg gap-5 mx-auto mt-4 mb-8 md:mt-8 lg:mt-32'>
        <h1 className='text-xl font-semibold text-center'>
          {notificationData?.header}
        </h1>
        <div className='overflow-hidden h-80 rounded-xl'>
          <img
            src={notificationItem.image}
            alt='notification-image'
            className='rounded-xl'
          />
        </div>

        <p className='text-center'>{notificationData.body}</p>

        <Button onClick={onNavigate}>{notificationData.cta}</Button>
      </div>
    </div>
  );
}
